export default __webpack_public_path__ + "836326a59b52ccd3e32dd1274a632158.svg";